/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITiposUnidades from 'Infotrack@Modelos/smartStock/tiposUnidades/entidades/tiposUnidades';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import TiposUnidadesCM from '../controladorModelo/tiposUnidadesCM';
import { IFormularioTiposUnidadesCVProps } from '../interfaces';
import { acciones, IEstadoTiposUnidades } from '../reductorTiposUnidades';
import FormularioTiposUnidadesVista from '../vista/formularioTiposUnidadesVista';
import { useSelector } from 'react-redux';

const estadoInicial: ITiposUnidades = {
    EmpresaId: '',
    DescripcionTipoUnidad: '',
    Estado: 1,
    AgenciaId: '',
};
const tiposUnidadesCM = new TiposUnidadesCM();

const FormularioTiposUnidadesCV: React.FunctionComponent<IFormularioTiposUnidadesCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadTiposUnidades }, dispatch] = useProveedor<IEstadoTiposUnidades>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<ITiposUnidades>(estadoInicial);

    React.useEffect(() => {
        if (entidadTiposUnidades && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadTiposUnidades);
        } else {
            reiniciar();
        }
    }, [entidadTiposUnidades]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionTiposUnidades = () => {
        if (tiposUnidadesCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarTiposUnidades,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarTiposUnidades = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            tiposUnidadesCM
                .crearTiposUnidades({ ...valor, EmpresaId: IdEmpresa, AgenciaId: idAgencia, Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0 })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            tiposUnidadesCM
                .editarTiposUnidades({
                    ...valor,
                    EmpresaId: IdEmpresa,
                    AgenciaId: idAgencia,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioTiposUnidadesVista
            accionCrearEditar={confirmarCreacionEdicionTiposUnidades}
            cambiarInfoFomulario={alCambiarValor}
            tiposUnidades={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioTiposUnidadesCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
});

export default connect<IFormularioTiposUnidadesCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioTiposUnidadesCV);
